module.exports = __webpack_public_path__ + "img/man-pushing-cart.f2890356.png";